import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-p-3" }
const _hoisted_3 = { class: "tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-gap-3" }
const _hoisted_4 = { class: "tw-flex-1" }
const _hoisted_5 = {
  key: 0,
  class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap tw-justify-end"
}
const _hoisted_6 = ["onClick", "disabled"]
const _hoisted_7 = {
  key: 0,
  class: "tw-opacity-60"
}
const _hoisted_8 = { class: "tw-mt-2 tw-flex tw-items-center tw-justify-between tw-text-[11px] tw-text-slate-500 tw-pt-2 tw-border-t tw-border-slate-100" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-gap-3" }
const _hoisted_13 = {
  key: 0,
  class: "tw-italic"
}
const _hoisted_14 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "tw--m-5" }
const _hoisted_17 = { class: "tw-mt-4 tw-text-sm tw-text-slate-700" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "tw-p-4"
}
const _hoisted_20 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-6"
}
const _hoisted_21 = { class: "tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-600" }
const _hoisted_22 = { class: "tw-inline-flex tw-min-w-[28px] tw-justify-center tw-rounded-full tw-bg-slate-900/5 tw-px-2 tw-py-0.5 tw-text-xs tw-text-slate-700" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  class: "tw-mt-4 tw-flex tw-justify-center"
}
const _hoisted_25 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "tw-flex tw-items-center tw-gap-1" }
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = { class: "tw-ml-2 tw-text-sm tw-text-slate-500" }
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_DispatchContainerModal = _resolveComponent("DispatchContainerModal")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DispatchTable = _resolveComponent("DispatchTable")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.searchTerm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            placeholder: "Container, BL or Customer...",
            class: "tw-w-full"
          }, null, 8, ["modelValue"])
        ]),
        (!_ctx.isSearchingInput)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['In Progress', 'Assigned (Pre-dispatch)', 'Available', 'Delivered', 'All'], (filter) => {
                return _createElementVNode("button", {
                  key: filter,
                  type: "button",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.activeFilter === filter
              ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
              : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                  onClick: ($event: any) => (_ctx.setFilter(filter)),
                  disabled: _ctx.isListLoading
                }, [
                  _createElementVNode("span", null, _toDisplayString(filter), 1),
                  (_ctx.activeFilter === filter)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.totalCount), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6)
              }), 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isSearchingInput)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _cache[5] || (_cache[5] = _createTextVNode("Results: ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.displayedContainers.length), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", null, "Showing " + _toDisplayString(_ctx.displayedContainers.length) + " of " + _toDisplayString(_ctx.totalCount), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tw-text-slate-300" }, "|", -1)),
                (_ctx.pageCount > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Page " + _toDisplayString(_ctx.pageNum + 1) + " of " + _toDisplayString(_ctx.pageCount), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isListLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Loading…"))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_14, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Rows", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "tw-rounded tw-border-slate-200 tw-bg-white tw-px-1 tw-py-0.5",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageSize) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 25, 50, 100], (size) => {
                return _createElementVNode("option", {
                  key: size,
                  value: size
                }, _toDisplayString(size), 9, _hoisted_15)
              }), 64))
            ], 512), [
              [
                _vModelSelect,
                _ctx.pageSize,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ]),
      _createVNode(_component_Modal, {
        isOpen: _ctx.isDispatchContainerOpen,
        "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDispatchContainerOpen) = $event)),
        modalId: "dispatch-container-view-modal",
        maxWidth: "7xl",
        hasCloseButton: false,
        onClose: _ctx.closeDispatchContainer
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_DispatchContainerModal, {
              containerId: _ctx.showTripForContainerIdx,
              onDispachContainerRefetch: _ctx.updateDispatchContainers,
              drivers: _ctx.drivers,
              filteredChassis: _ctx.chassis,
              onClose: _ctx.closeDispatchContainer
            }, null, 8, ["containerId", "onDispachContainerRefetch", "drivers", "filteredChassis", "onClose"])
          ])
        ]),
        _: 1
      }, 8, ["isOpen", "onClose"]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_ListPage, {
          variant: "card",
          loading: _ctx.isListLoading,
          cardPadding: false
        }, {
          default: _withCtx(() => [
            (!_ctx.isSearchingInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_DispatchTable, {
                    onToggleTripStatus: _ctx.toggleTripStatus,
                    onUpdateSortBy: _ctx.updateSortBy,
                    containers: _ctx.displayedContainers,
                    sortBy: _ctx.sortBy,
                    sortOrder: _ctx.sortOrder
                  }, null, 8, ["onToggleTripStatus", "onUpdateSortBy", "containers", "sortBy", "sortOrder"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSearchingInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_ctx.isServerSearching)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "circle-notch",
                          spin: "",
                          class: "tw-h-4 tw-w-4 tw-text-slate-500"
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "tw-text-sm tw-text-slate-600" }, "Searching on server...", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Results:", -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.displayedContainers.length), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSearchingInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_DispatchTable, {
                    onToggleTripStatus: _ctx.toggleTripStatus,
                    onUpdateSortBy: _ctx.updateSortBy,
                    containers: _ctx.displayedContainers,
                    sortBy: _ctx.sortBy,
                    sortOrder: _ctx.sortOrder
                  }, null, 8, ["onToggleTripStatus", "onUpdateSortBy", "containers", "sortBy", "sortOrder"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"]),
        (!_ctx.isSearching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.pageNum === 0 || _ctx.isListLoading
                }, " Prev ", 8, _hoisted_26),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (p, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (typeof p === 'string')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: `ellipsis-${index}`,
                            class: "tw-px-2 tw-text-sm tw-text-slate-500"
                          }, " ... "))
                        : (_openBlock(), _createElementBlock("button", {
                            key: `page-${p}`,
                            type: "button",
                            class: _normalizeClass(["tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-transition", p - 1 === _ctx.pageNum
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white']),
                            onClick: ($event: any) => (_ctx.goToPage(p - 1)),
                            disabled: _ctx.isListLoading
                          }, _toDisplayString(p), 11, _hoisted_28))
                    ], 64))
                  }), 256)),
                  _createElementVNode("span", _hoisted_29, "of " + _toDisplayString(_ctx.pageCount), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.pageNum + 1 >= _ctx.pageCount || _ctx.isListLoading
                }, " Next ", 8, _hoisted_30)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}